import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const GoodIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-good-icon ${className}`, height: '12.747', viewBox: '0 0 14.69 12.747', width: '14.69', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M11.179,12.747H5.261a1.317,1.317,0,0,1-1.315-1.316V4.862a1.318,1.318,0,0,1,.381-.927L7.969.292A.967.967,0,0,1,8.664,0a.982.982,0,0,1,.693.285.993.993,0,0,1,.27.9L9,4.2h3.716a1.976,1.976,0,0,1,1.815,2.749l-2.144,5A1.324,1.324,0,0,1,11.179,12.747Zm-9.864,0A1.317,1.317,0,0,1,0,11.431V6.17a1.315,1.315,0,1,1,2.63,0v5.261A1.317,1.317,0,0,1,1.315,12.747Z', fill: '#a1a7b2', id: 'Icon' }) })));
GoodIcon.propTypes = {
    className: propStr(),
};
GoodIcon.defaultProps = {
    className: '',
};
export default GoodIcon;
